import { Component, OnInit } from '@angular/core';
import { IntegrationService } from '../integration.service';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import {CdkDragDrop, moveItemInArray,CdkDragEnd} from '@angular/cdk/drag-drop';
import { Router } from '@angular/router';
import { NotifierService } from "angular-notifier";

import * as chrono from 'chrono-node'
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  private readonly notifier: NotifierService;
  public username = 'My';
  subscriptionPlan;
  listViewPromoScreen;
  checkoutUrl;

  constructor(notifierService: NotifierService,private _integrationService:IntegrationService,private http:HttpClient,public modalService:NgbModal,private router:Router,private sanitizer: DomSanitizer) {
    this._integrationService.userId$.subscribe((data)=>{this.showSubscriptions(data)});
    this._integrationService.userName$.subscribe((data)=>{this.username=`${data[0].toUpperCase()}${data.slice(1,)}`});
    this._integrationService.subscriptionPlan$.subscribe((data)=>{this.subscriptionPlan=data;this.planLoading=false;})
    this._integrationService.listViewPromo$.subscribe((data)=>{this.listViewPromoScreen=data})
    this._integrationService.checkoutUrl$.subscribe((data)=>{this.checkoutUrl=data})
    this.notifier = notifierService;

   }
  subscriberId;
  email;
  phone;
  subscriptions;
  subscriptionsArray = [];
  expiryDate;
  objectKeys = Object.keys
  closeResult: string;
  loading = true;
  planLoading = true;
  currSubscriptionId = '';
  currSubscriptionName = '';
  currSubscriptionPrice = '';
  currSubscriptionStart = '';
  currSubscriptionExpiry = '';
  currSubscriptionUrl = '';
  currSubscriptionCycle = '';
  currSubscriptionStatus = '';
  buttonLoading = false;
  priceChevronClass = 'fas fa-chevron-down'
  dateChevronClass = 'fas fa-chevron-down'
  statusChevronClass = 'fas fa-chevron-down'
  view = localStorage.getItem('view') || 'tile'


  open(content,subscription='',subscriptionId='') {
    // console.log(JSON.stringify(subscription),subscriptionId)
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
    // console.log(subscription)
    this.currSubscriptionName = subscription['name'];
    this.currSubscriptionPrice = subscription['price'] ? subscription['price'] : 'N/A';
    this.currSubscriptionStart = subscription['date_subscribed'];
    this.currSubscriptionExpiry = subscription['next_bill'];
    this.currSubscriptionStatus = subscription['status'];
    this.currSubscriptionCycle = subscription['payment_sched'];
    this.currSubscriptionUrl = subscription['url']
    this.currSubscriptionId = subscriptionId;

  }

  openAdd(content){
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  openListViewPromo(content){
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title',size:'xl'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this._integrationService.listViewPromoSubject.next(0)
      this._integrationService.getUser();
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  openBreakdownPromo(content){
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  showSubscriptions(userId){
    this.subscriberId = userId.replace(/"/g,"");
    let subscriptions_endpoint = 'https://subscrybe-backend.herokuapp.com/user-subscriptions/' + userId.replace(/"/g,"")
    this.http.get(subscriptions_endpoint).subscribe(
      subscription_data =>{
        this.loading=false;
        this.subscriptions = {}
        for(let key = 0;key<Object.keys(subscription_data).length;key++){
          let objKey = Object.keys(subscription_data)[key].replace(/"/g,"")
          let thisSub = subscription_data[Object.keys(subscription_data)[key]]
          thisSub['logoExists'] = true;
          this.http.get(`https://logo.clearbit.com/${thisSub.url}`).subscribe(data=>{
            // console.log('ye')
          },error=>{
            if(error.status != 200){
              thisSub['logoExists'] = false;
            }
            
          })
          this.subscriptions[objKey] = thisSub
          let newArray = [objKey,thisSub]
          if(!this.subscriptionsArray.includes(newArray)){
            this.subscriptionsArray.push(newArray)
          }
          
        }
      }
    )
    console.log(this.subscriptionsArray)
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }

  updateSubscription(subName='',subUrl='',subExpiry='',subSched='',price='$21'){
    let reqBody = {
      subscriptionName:subName,
      subscriptionUrl: subUrl,
      nextBillDate:chrono.parseDate(subExpiry).toISOString().slice(0,10),
      paymentSched:subSched,
      price:price
    }
    let endpoint = `https://subscrybe-backend.herokuapp.com/subscriptions/${this.currSubscriptionId}`
    console.log(endpoint)
    this.http.patch(endpoint,reqBody).subscribe(data=>{
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/dashboard']);
      }); 
      this.notifier.notify("success", "Subscription Updated");
    },error=>{
      console.log(error)
      this.notifier.notify("error", "Error updating subscription");
    })
  }

  deleteSubscription(){
    let endpoint = `https://subscrybe-backend.herokuapp.com/subscriptions/${this.currSubscriptionId}`
    this.http.delete(endpoint).subscribe(data=>{
      console.log(data)
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/dashboard']);
      }); 
      this.notifier.notify("success", "Subscription Deleted");
    },error=>{
      this.notifier.notify("error", "Error deleting subscription");
    })
  }

  addSubscription(newSubName='',newSubUrl='',newSubExpiry='',newSubSched='',price='$10'){
    this.buttonLoading = true;
    let reqBody = {
      subscriberId:this.subscriberId,
      subscriptionName:newSubName,
      subscriptionUrl: newSubUrl,
      nextBillDate:chrono.parseDate(newSubExpiry).toISOString().slice(0,10),
      paymentSched:newSubSched,
      price:price,
      method:'dashboard'
    }
    let endpoint = 'https://subscrybe-backend.herokuapp.com/add-subscription'
    this.http.post(endpoint,reqBody).subscribe(data=>{
      this.subscriptionsArray = [];
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/dashboard']);
      }); 
      this.buttonLoading = false;
      this.notifier.notify("success","Successfully added subscription")
    },error=>{
      this.notifier.notify("error", "Error adding subscription");
      this.buttonLoading = false;
    }
    )
  }


  isPaymentSched(sched='',req=''){
    return sched == req;
  }

  expiringSoon(date,get=false){
    let expiry = new Date(date)
    let today = new Date()
    let timeDiff = expiry.getTime() - today.getTime(); 
    let daysDiff = timeDiff / (1000 * 3600 * 24);
    if(daysDiff >= 0 && daysDiff <=3 || get){
      return `${Math.ceil(daysDiff)} Day${Math.ceil(daysDiff) > 1 ? 's' : ''}`;
    }
    return false;
  }


  manageAlerts(id){
    let endpoint = `https://subscrybe-backend.herokuapp.com/managealerts/${id}`
    let reqBody = {}
    this.http.post(endpoint,reqBody).subscribe(data=>{
      this.notifier.notify("success", "Alerts Updated");
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/dashboard']);
      }); 
    },error=>{
      console.log(error)
      this.notifier.notify("error", "Error updating alerts, try again");
    })
  }



  findId(status){
    if(status == 'active'){
      return 'pause-btn';
    } else{
      return 'resume-btn'
    }
  }

  formattedDate(date){
    return new Date(date).toDateString();
  }

  ngOnInit() {
    this._integrationService.getUser();
    this._integrationService.userId$.subscribe((data)=>{this.subscriberId=data.replace(/"/g,"")});
    this._integrationService.subscriptionPlan$.subscribe((data)=>{this.subscriptionPlan=data})
    this._integrationService.showNavSubject.next(true)
    let upgradedNotif = localStorage.getItem('upgradedNotif')
    this.modalService.dismissAll();
    // if(upgradedNotif == 'true'){
    //   this.notifier.notify('success','You have successfully upgraded to premium :), and have now been granted access to premium features!')
    //   localStorage.setItem('upgradedNotif','false')
    // }
    }

  getView(view){
    return this.view == view ? 'selectedView' : 'unselectedView';
  }

  changeView(view){
    if(this.subscriptionPlan == 'subscrybe-premium'){
      this.view = view;
      localStorage.setItem('view',view)
    }
  }

  getStatus(status){
    //
  }

  getStatusId(status,date){
    if(status == 'cancelled'){
      return 'cancelled'
    } else if(status == 'alerts paused'){
      return 'expiring'
    } else if(status == 'active'){
      return this.formatStatus(status,date).includes('Renews') ? 'expiring' : 'active'
    }
  }

  formatStatus(status,date){
    switch(status){
      case 'alerts paused':
        return 'Alerts Paused'
      case 'cancelled':
        return 'Cancelled'
      case 'active':
        return this.expiringSoon(date) ? `Renews in ${this.expiringSoon(date)}` : 'Active'
    }
  }

  drop(event: CdkDragDrop<string[]>) {
    // console.log(this.objectKeys(this.subscriptions))
    // console.log(Object.keys(this.subscriptions))
    // console.log(this.subscriptionsArray)
    // console.log(event.currentIndex,this.subscriptions[this.objectKeys(this.subscriptions)[event.currentIndex]])
    console.log(event)
    // [this.subscriptionsArray[0], this.subscriptionsArray[1]] = [this.subscriptionsArray[1], this.subscriptionsArray[1]];
    moveItemInArray(this.subscriptionsArray, event.previousIndex,event.currentIndex);
  }


  dragEnd(event: CdkDragEnd) {
    console.log(event.distance);
  }

  onDragEnd(event: DragEvent) {
    console.log('drag end', event);
    // Show dragged element again
    // event.target.style.opacity = 1;
  }

  sortByPrice(){
    let prices = []
    let subscriptionEntries = Object.entries(this.subscriptions)
    let sortedEntries = []
    subscriptionEntries.map((a)=>{prices.push([parseFloat(a[1]['price'].replace('$','')),a])})
    // subscriptionValues.map((a)=>{prices.push([parseFloat(a.price.replace('$','')),a.name])})
    if(this.priceChevronClass == 'fas fa-chevron-down'){
      this.priceChevronClass = 'fas fa-chevron-up'
      prices.sort((a,b)=>(a[0]-b[0]))
      for(let price of prices){
        sortedEntries.push(price[1])
      }
      this.subscriptionsArray = sortedEntries;
    } else {
      this.priceChevronClass = 'fas fa-chevron-down'
      prices.sort((a,b)=>(b[0]-a[0]))
      for(let price of prices){
        sortedEntries.push(price[1])
      }
      this.subscriptionsArray = sortedEntries;
    }
  }



  sortByDate(){
    let dates=[]
    let subscriptionEntries = Object.entries(this.subscriptions)
    let sortedEntries = []
    subscriptionEntries.map((a)=>{dates.push([a[1]['next_bill'],a])})
    // subscriptionValues.map((a)=>{prices.push([parseFloat(a.price.replace('$','')),a.name])})
    this.subscriptionsArray = sortedEntries;
    if(this.dateChevronClass == 'fas fa-chevron-down'){
      this.dateChevronClass = 'fas fa-chevron-up'
      dates.sort((a,b)=>(new Date(a[0]).valueOf() - new Date(b[0]).valueOf()))
      for(let date of dates){
        sortedEntries.push(date[1])
      }
      this.subscriptionsArray = sortedEntries;
    } else{
      this.dateChevronClass = 'fas fa-chevron-down'
      dates.sort((a,b)=>(new Date(b[0]).valueOf() - new Date(a[0]).valueOf()))
      for(let date of dates){
        sortedEntries.push(date[1])
      }
      this.subscriptionsArray = sortedEntries;
    }

  }

  sortFunction = (a, b) => {
    if(a[0] < b[0]) { return -1; }
    if(a[0] > b[0]) { return 1; }
    return 0;
   }

   inverseSort = (a, b) => {
    if(a[0] > b[0]) { return -1; }
    if(a[0] < b[0]) { return 1; }
    return 0;
   }

   

  sortByStatus(){
    let statuses=[]
    let subscriptionEntries = Object.entries(this.subscriptions)
    let sortedEntries = []
    subscriptionEntries.map((a)=>{statuses.push([a[1]['status'],a])})
    if(this.statusChevronClass == 'fas fa-chevron-down'){
      this.statusChevronClass = 'fas fa-chevron-up'
      statuses.sort(this.sortFunction)
      for(let status of statuses){
        sortedEntries.push(status[1])
      }
      this.subscriptionsArray = sortedEntries;
    } else{
      this.statusChevronClass = 'fas fa-chevron-down'
      statuses.sort(this.inverseSort)
      for(let status of statuses){
        sortedEntries.push(status[1])
      }
      this.subscriptionsArray = sortedEntries;
    }
  }

  getBreakdown(){
    this.router.navigate(['/breakdown'])
  }

  getColor(url='',logoExists=false){
    if(!logoExists){
      return {'background-color':'#'+(Math.random()*0xFFFFFF<<0).toString(16)}
    }
    return {'background': `url(https://logo.clearbit.com/${url.replace('netflix','netflixinvestor')})`,'background-repeat':'no-repeat','height':'175px','background-position':'center'}
    
  }

  cleanUrl(url){
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
